'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ExportIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ExportIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Archive--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <path
          d="M23.5 7a1 1 0 0 1 -1 1h-21a1 1 0 0 1 -1 -1V4a1 1 0 0 1 1 -1h21a1 1 0 0 1 1 1Z"
          fill="none"
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M22.5 10v10a1 1 0 0 1 -1 1h-19a1 1 0 0 1 -1 -1V10"
          fill="none"
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M15.5 12.5A1.5 1.5 0 0 1 14 14h-4a1.5 1.5 0 0 1 0 -3h4a1.5 1.5 0 0 1 1.5 1.5Z"
          fill="none"
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

ExportIcon.propTypes = {
  sx: PropTypes.object
}
